module.exports = __webpack_public_path__ + "img/chever.15e3cbba.svg";